import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosMenuItem,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import ModalHeaderCloseCustom from "../../ModalHeaderCloseCustom/HeaderModalCloseButton";

export default function PushAuditNote(props) {
    const { i18n, pushModal, reload } = useGlobalValue();
    const { value: cell } = props || {};
    const { id, entity, projectId, fiscalYear, modulePrefix, importId } = cell || {};
    return (
        <SovosBox>
            <SovosToolbar
                sx={{
                    backgroundColor: "transparent !important",
                }}
            >
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu>
                        <SovosMenuItem
                            onClick={() => {
                                pushModal({
                                    title: i18n`Audit Log Details`,
                                    args: {
                                        id,
                                        entity,
                                        projectId,
                                        fiscalYear,
                                        modulePrefix,
                                        importId,
                                    },
                                    view: "AuditLogDetails",
                                    modalType: "audit",
                                    customHeaderButton: ModalHeaderCloseCustom,
                                })
                                    .then(() => reload && reload())
                                    .catch(() => ({}));
                            }}
                        >
                            <SovosTypography children={i18n`audit_logs`} variant={"span"} />
                        </SovosMenuItem>
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>
        </SovosBox>
    );
}
